import React from 'react';

const TODO = () => (
	<div>
		<h1>PAGE UNDER CONSTRUCTION</h1>
	</div>
);

export default TODO;